var Cookie = (function() {
  function createCookie(name, value, options) {
    options = options || {};

    /** 
      options = {
        expires       : 쿠키 만료일    :   new Date(year, month, day, hours, minutes, seconds, milliseconds)
        expires_day   : 쿠키 유지일    :   숫자
        expires_hour  : 쿠키 유지시간  :   숫자
        domain        : 도메인					:   wwww.waglebagle.net
        path          : 경로					:    / 또는 /dir    
        secure        : ssl						: true / false
      }
    **/

    this.cookie_arr = [escape(name) + "=" + escape(value)];

    //-- expires
    if (options.expires) {
      if (typeof options.expires === "object" && options.expires instanceof Date) {
        var date = options.expires;
        var expires = "expires=" + date.toUTCString();
        this.cookie_arr.push(expires);
      }
    } else if (options.expires_day) {
      this.set_expires_date(options.expires_day, 24 * 60 * 60);
    } else if (options.expires_hour) {
      this.set_expires_date(options.expires_hour, 60 * 60);
    }

    //-- domain
    if (options.domain) {
      var domain = "domain=" + options.domain;
      this.cookie_arr.push(domain);
    }

    //-- path
    if (options.path) {
      var path = "path=" + options.path;
      this.cookie_arr.push(path);
    }

    //-- secure
    if (options.secure === true) {
      var secure = "secure";
      this.cookie_arr.push(secure);
    }

    document.cookie = this.cookie_arr.join("; ");
  }

  function deleteCookie(name) {
    document.cookie = name + "=''; expires='" + new Date(0).toGMTString() + ";";
  }

  function parseCookie() {
    var cookies = {};
    decodeURIComponent(document.cookie)
      .split(";")
      .forEach(function(val) {
        var cookie = val.trim().split("=");
        cookies[cookie[0]] = decodeURIComponent(cookie[1]);
      });
    return cookies;
  }

  return {
    createCookie: createCookie,
    deleteCookie: deleteCookie,
    parseCookie: parseCookie
  };
})();

export default Cookie;



// WEBPACK FOOTER //
// ./member/js/cookie.js